// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "rs-encrypted-input",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class EncryptedInputComponent implements OnInit {
  @Input() value;
  @Input() disabled = false;
  @Input() error = false;
  @Input() placeholder = "";

  @Output()
  valueChange = new EventEmitter();
  encrypted = true;
  ngOnInit() {}
  onInput(event) {
    const value = event.target.value;
    this.valueChange.emit(value);
  }
}
